module.exports = __webpack_public_path__ + "img/video-game.ab302b06.svg";